import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { History } from 'history';
import { appEnv } from '../_env';

export function initSentry(history: History) {
   if (appEnv.sentryEnabled) {
      Sentry.init({
         dsn: 'https://b9fa7d0ab05f4d6fb28f50480fd0378e@o504589.ingest.sentry.io/5591681',
         integrations: [
            new Integrations.BrowserTracing({
               routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
            }),
         ],
         // Context depth (redux state most notably)
         normalizeDepth: 10,
         maxBreadcrumbs: 20,
         tracesSampleRate: 0.05,
         release: appEnv.sentryVersion,

         //sentry env: if undefined sentry set default to "production"
         environment: appEnv.sentryEnv,
         beforeSend(event, hint) {
            const error = hint.originalException;
            if (error instanceof Error && error.message && /ReferenceError/.test(error.message)) {
               return null;
            }
            return event;
         },
      });
   }
}
